module.exports = __webpack_public_path__ + "static/media/img_contact.b6b9a4c0.png";